import React, { useState } from 'react';

// MUI components
import Box from '@mui/material/Box';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

// MUI Icon
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';

// Section for type definition -----------------------------------------------------------------------------------------

import Sort from 'types/components/MansionNavigation/Sort';

interface CitiesSortMenuProps {
  sortMenu: Sort;
}

type SortKey = keyof Sort;

function ListSortMenu({ sortMenu }: CitiesSortMenuProps) {
  const queryParams = new URLSearchParams(window.location.search);
  const initialSortValue = queryParams.get('sort');
  const defaultSortKey: string = 'point_desc';
  const initialSortKey: string = initialSortValue || defaultSortKey;

  const [selectedSortKey, setSelectedSortKey] = useState<string>(initialSortKey);

  const handleSelectChange = (event: SelectChangeEvent) => {
    const newSortValue = event.target.value as SortKey;
    setSelectedSortKey(newSortValue);

    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('sort', newSortValue);

    window.location.href = currentUrl.toString();
  };

  return (
    <Box>
      <Select
        value={selectedSortKey}
        onChange={handleSelectChange}
        IconComponent={KeyboardArrowDownRoundedIcon}
        sx={{
          fontSize: '14px',
          padding: '2px 6px',
          height: '24px',
          color: '#119CDA',
          '.MuiOutlinedInput-notchedOutline': {
            borderColor: 'transparent',
            borderWidth: 0,
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'transparent',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'transparent',
          },
        }}
        className="bg-gray-01 rounded-full"
      >
        {Object.keys(sortMenu).map((key) => {
          const sortKey = key as SortKey;
          return (
            <MenuItem key={sortKey} value={sortKey}>
              {sortMenu[sortKey].display}
            </MenuItem>
          );
        })}
      </Select>
    </Box>
  );
}

export default ListSortMenu;
